import { createApi } from '@reduxjs/toolkit/query/react';

import {
  LegalEntitiesEndpoints as Endpoints,
  type GetLegalEntitiesForSystemRequest,
  type GetLegalEntitiesForSystemResponse,
  type GetLegalEntitiesRequest,
  type GetLegalEntitiesResponse,
  type GetLegalEntityByIdRequest,
  type GetLegalEntityByIdResponse,
  type UpdateLegalEntityRequest,
  type UpdateLegalEntityResponse,
} from '@app/api/LegalEntities/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { LEGAL_ENTITIES } from '@app/constants';

export const legalEntitiesApi = createApi({
  reducerPath: 'legalEntitiesApi',
  baseQuery: createApiBaseQuery(LEGAL_ENTITIES),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.UpdateLegalEntity]: mutation<
      UpdateLegalEntityResponse,
      UpdateLegalEntityRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdateLegalEntity,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetLegalEntities]: query<
      GetLegalEntitiesResponse,
      GetLegalEntitiesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetLegalEntities,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetLegalEntitiesForSystem]: query<
      GetLegalEntitiesForSystemResponse,
      GetLegalEntitiesForSystemRequest
    >({
      query: (params) => ({
        url: Endpoints.GetLegalEntitiesForSystem,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetLegalEntityById]: query<
      GetLegalEntityByIdResponse,
      GetLegalEntityByIdRequest
    >({
      query: (params) => ({
        url: Endpoints.GetLegalEntityById,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useUpdateLegalEntityMutation,
  useGetLegalEntitiesQuery,
  useLazyGetLegalEntitiesQuery,
  useGetLegalEntitiesForSystemQuery,
  useLazyGetLegalEntitiesForSystemQuery,
  useGetLegalEntityByIdQuery,
  useLazyGetLegalEntityByIdQuery,
} = legalEntitiesApi;
